import React from "react";
import { useState, useRef } from "react";
import { Alert, Container, Box, Stack, Button, Typography, Avatar, IconButton, TextField, InputLabel, MenuItem, Modal, styled, Checkbox, FormControlLabel } from "@mui/material";
import ContentBox from "../../components/ui/ContentBox";
import { colors } from "../../theme/Colors";
import { Formik, Form, Field, ErrorMessage } from "formik";
import MyDP from "../../components/ui/MyDP";
import TextareaAutosize from "@mui/base/TextareaAutosize";
import * as Yup from "yup";
import moment from "moment";
import DoneRoundedIcon from "@mui/icons-material/DoneRounded";
import ClearRoundedIcon from "@mui/icons-material/ClearRounded";
import { modalStyle } from "../../theme/ModalStyle";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import Api from "../../api/Api";
import { Urls } from "../../api/Urls";

const Label = styled(InputLabel)({
  color: `${colors.textDark}`,
  fontSize: "0.875rem",
  marginBottom: ".5rem",
});

const MyTextField = styled(TextField)({
  width: "100%",
});

const ErrorText = styled(Box)({
  color: `${colors.mj_error}`,
  fontSize: "0.875rem",
});

function CvFormation({ formations, setFormations, access_token, setChange, idInt }) {
  //refs
  const formationRef = useRef();
  const formationRef2 = useRef();
  const dateFinRef = useRef();
  const doneRef = useRef();

  //states
  const [isAddingFormation, setIsAddingFormation] = useState(false);
  const [checked, setChecked] = useState(false);
  const [id, setId] = useState(null);
  const [checkedModif, setCheckedModif] = useState(false);
  const [calendarColor, setCalendarColor] = useState(`${colors.main}`);
  const [open, setOpen] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);

  const initialValuesFormation = {
    name: "",
    school_name: "",
    location: "",
    start_date: "",
    end_date: "",
  };

  const validationSchemaFormation = Yup.object({
    name: Yup.string().required("Ce champs est obligatoire"),
    school_name: Yup.string().required("Ce champs est obligatoire"),
    location: Yup.string().required("Ce champs est obligatoire"),
    start_date: Yup.date().required("Ce champs est obligatoire"),
  });

  //modal functions
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  const onChangeCheckbox = (event) => {
    setChecked(event.target.checked);
    calendarColor === `${colors.main}` ? setCalendarColor(`${colors.paperLightGrayBorder}`) : setCalendarColor(`${colors.main}`);
    if (formationRef.current) {
      formationRef.current.setFieldValue("end_date", null);
    }
  };
  const onChangeCheckbox2 = (event) => {
    setChecked(event.target.checked);
    calendarColor === `${colors.main}` ? setCalendarColor(`${colors.paperLightGrayBorder}`) : setCalendarColor(`${colors.main}`);
    if (formationRef2.current) {
      formationRef2.current.setFieldValue("end_date", null);
    }
  };
  return (
    <Box>
      <Box display="flex" flexDirection="row" sx={{ margin: "2rem 0.5rem 1rem 0.5rem", mt: "" }}>
        <Typography mr="0.3rem" display="inline-block" fontSize="1.3rem">
          Formation{" "}
        </Typography>
      </Box>

      {formations?.map((f) => {
        let startDate = new Date(f.start_date);
        let endDate = new Date(f.end_date);

        return (
          <ContentBox mb="1rem" display="flex" flexDirection="column" key={f.id}>
            <Modal open={open} onClose={handleClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box sx={modalStyle}>
                <Typography variant="h6" component="h2">
                  Supprimer une formation
                </Typography>
                <Typography sx={{ mt: 2, mb: 4 }}>Voulez vous vraiment supprimer cette formation?</Typography>
                <Box display="flex" justifyContent="center" gap="1rem">
                  <Button
                    variant="mj_primary"
                    onClick={() => {
                      Api.delete(Urls.DELETE_FORM + id, {
                        headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
                      })
                        .then((res) => {
                          console.log(res);
                          handleClose();
                          setChange((change) => change + 1);
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                      handleClose();
                    }}
                  >
                    Supprimer
                  </Button>
                  <Button variant="mj_secondary" onClick={handleClose}>
                    Annuler
                  </Button>
                </Box>
              </Box>
            </Modal>

            <Modal open={openEdit} onClose={handleCloseEdit} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
              <Box sx={modalStyle}>
                <Typography variant="h6" component="h2">
                  Modifier une formation
                </Typography>
                <Box>
                  <Formik
                    innerRef={formationRef2}
                    initialValues={{ name: f.name, school_name: f.school_name, location: f.location, start_date: f.start_date, end_date: f.end_date }}
                    validationSchema={validationSchemaFormation}
                    onSubmit={(values) => {
                      Api.post(
                        Urls.UPDATE_FORM + id + "/update",
                        {
                          name: values.name,
                          school_name: values.school_name,
                          location: values.location,
                          start_date: values.start_date,
                          end_date: values.end_date,
                        },
                        {
                          headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
                        }
                      )
                        .then((res) => {
                          handleCloseEdit();
                          setChange((change) => change + 1);
                        })
                        .catch((err) => {
                          console.log(err);
                        });

                      //handleCloseEdit();
                      console.log(values);
                    }}
                  >
                    {({ values, setFieldValue }) => (
                      <Form>
                        <Box flexDirection="column" sx={{ margin: "1rem 0.5rem" }}>
                          <Label htmlFor="name">Intitulé de la formation</Label>
                          <Field name="name" type="input" placeholder="Formation" id="name" as={MyTextField} autoComplete="off" />
                          <ErrorMessage component={ErrorText} name="name" />
                        </Box>
                        <Box flexDirection="column" sx={{ margin: "1rem 0.5rem" }}>
                          <Label htmlFor="school_name">Université</Label>
                          <Field name="school_name" type="input" placeholder="Université" id="school_name" as={MyTextField} autoComplete="off" />
                          <ErrorMessage component={ErrorText} name="school_name" />
                        </Box>
                        <Box flexDirection="column" sx={{ margin: "1rem 0.5rem" }}>
                          <Label htmlFor="location">Lieu</Label>
                          <Field name="location" type="input" placeholder="Lieu" id="location" as={MyTextField} autoComplete="off" />
                          <ErrorMessage component={ErrorText} name="location" />
                        </Box>
                        <Box className="debutFin" display="flex" sx={{ flexDirection: { md: "row", xs: "column" } }} marginBottom="1rem">
                          <Box flex={1} display="flex" flexDirection="column" sx={{ margin: "0rem 0.5rem" }}>
                            <Label htmlFor="start_date">Date de début</Label>
                            <Field setFieldValue={setFieldValue} max={values.end_date ? values.end_date : new Date()} name="start_date" color={colors.main} type="input" id="start_date" as={MyDP} autoComplete="off" />
                            <ErrorMessage component={ErrorText} name="start_date" />
                          </Box>

                          <Box flex={1} display="flex" flexDirection="column" sx={{ margin: { md: "0rem 0.5rem", xs: "1rem 0.5rem" } }}>
                            <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
                              <Label htmlFor="end_date">Date de fin</Label>

                              <Box display="flex" flexDirection="row" gap="0.5rem" justifyContent="center" marginBottom="0rem">
                                <Label sx={{ margin: "0rem" }} htmlFor="end_date">
                                  Jusqu'à présent
                                </Label>
                                <Checkbox
                                  onChange={(e) => {
                                    setCheckedModif(e.target.checked);
                                    if (e.target.checked === true) setFieldValue("end_date", initialValuesFormation.end_date);
                                    else setFieldValue("end_date", initialValuesFormation.end_date);
                                  }}
                                  checked={checkedModif}
                                  disableRipple
                                  sx={{ padding: "0rem", marginBottom: "0.3rem" }}
                                />
                              </Box>
                            </Box>
                            <Field setFieldValue={setFieldValue} min={values.start_date} max={new Date()} disabled={checkedModif} color={calendarColor} name="end_date" type="input" id="end_date" as={MyDP} autoComplete="off" />
                            <ErrorMessage component={ErrorText} name="end_date" />
                          </Box>
                        </Box>

                        {/* <Box width="6rem">
                          <pre>{JSON.stringify(values, null, 2)}</pre>
                          <pre>{JSON.stringify(checked, null, 2)}</pre>
                        </Box> */}
                        <Box display="flex" justifyContent="center" gap="1rem">
                          <Button variant="mj_primary" type="submit">
                            Modifier
                          </Button>
                          <Button variant="mj_secondary" onClick={handleCloseEdit}>
                            Annuler
                          </Button>
                        </Box>
                      </Form>
                    )}
                  </Formik>
                </Box>
              </Box>
            </Modal>

            <Typography sx={{ lineHeight: "26px" }} fontWeight="500">
              {f.name} {" - "}
              {f.school_name}
            </Typography>
            <Box>
              <Typography sx={{ lineHeight: "26px" }} fontWeight="500">
                {f?.location ? f.location : "-"}
              </Typography>
              <Typography sx={{ lineHeight: "26px" }} fontWeight="500">
                {"(" + startDate.toLocaleDateString("fr-fr", { year: "numeric", month: "short" })}
                {" - "}
                {f.end_date ? endDate.toLocaleDateString("fr-fr", { year: "numeric", month: "short" }) + ")" : "jusqu'à présent)"}
              </Typography>
            </Box>
            <Box display="flex" flexDirection="row" justifyContent="center" gap="1.5rem" sx={{ mt: 2 }}>
              <IconButton
                sx={{ padding: "0.5rem", bgcolor: `${colors.main}`, "&:hover": { bgcolor: `${colors.light}` } }}
                onClick={() => {
                  handleOpenEdit();
                  setId(f.id);
                }}
              >
                <EditIcon sx={{ color: `white` }} fontSize="medium" />
              </IconButton>
              <IconButton
                sx={{ padding: "0.5rem", bgcolor: `${colors.main}`, "&:hover": { bgcolor: `${colors.light}` } }}
                onClick={() => {
                  handleOpen();
                  setId(f.id);
                }}
              >
                <DeleteOutlinedIcon sx={{ color: `white` }} fontSize="medium" />
              </IconButton>
            </Box>
          </ContentBox>
        );
      })}

      <Box flexDirection="column">
        <Box display="flex" justifyContent="center">
          <Button variant="mj_primary" onClick={() => setIsAddingFormation(true)}>
            Ajouter une formation
          </Button>
        </Box>

        {isAddingFormation ? (
          //FORM ADD FORMATION
          <Box>
            <Formik
              innerRef={formationRef}
              initialValues={initialValuesFormation}
              validationSchema={validationSchemaFormation}
              onSubmit={(values) => {
                Api.post(
                  Urls.CREATE_FORM + idInt + "/create-formation",
                  {
                    name: values.name,
                    school_name: values.school_name,
                    location: values.location,
                    start_date: values.start_date,
                    end_date: values.end_date,
                  },
                  {
                    headers: { "content-type": "application/json", authorization: `Bearer ${access_token}` },
                  }
                )
                  .then((res) => {
                    console.log(res);
                    setChange((change) => change + 1);
                    setIsAddingFormation(false);
                    handleClose();
                  })
                  .catch((err) => {
                    console.log(err);
                  });
              }}
            >
              {({ values, setFieldValue }) => (
                <Form>
                  <Box flexDirection="column" sx={{ margin: "1rem 0.5rem" }}>
                    <Label htmlFor="name">Intitulé de la formation</Label>
                    <Field name="name" type="input" placeholder="Formation" id="name" as={MyTextField} autoComplete="off" />
                    <ErrorMessage component={ErrorText} name="name" />
                  </Box>
                  <Box flexDirection="column" sx={{ margin: "1rem 0.5rem" }}>
                    <Label htmlFor="school_name">Université</Label>
                    <Field name="school_name" type="input" placeholder="Université" id="school_name" as={MyTextField} autoComplete="off" />
                    <ErrorMessage component={ErrorText} name="school_name" />
                  </Box>
                  <Box flexDirection="column" sx={{ margin: "1rem 0.5rem" }}>
                    <Label htmlFor="location">Lieu</Label>
                    <Field name="location" type="input" placeholder="Lieu" id="location" as={MyTextField} autoComplete="off" />
                    <ErrorMessage component={ErrorText} name="location" />
                  </Box>
                  <Box className="debutFin" display="flex" sx={{ flexDirection: { md: "row", xs: "column" } }}>
                    <Box flex={1} display="flex" flexDirection="column" sx={{ margin: "0rem 0.5rem" }}>
                      <Label htmlFor="start_date">Date de début</Label>
                      <Field setFieldValue={setFieldValue} max={values.end_date ? values.end_date : new Date()} name="start_date" color={colors.main} type="input" id="start_date" as={MyDP} autoComplete="off" />
                      <ErrorMessage component={ErrorText} name="start_date" />
                    </Box>

                    <Box flex={1} display="flex" flexDirection="column" sx={{ margin: { md: "0rem 0.5rem", xs: "1rem 0.5rem" } }}>
                      <Box display="flex" flexDirection="row" alignItems="center" justifyContent="space-between">
                        <Label htmlFor="end_date">Date de fin</Label>

                        <Box display="flex" flexDirection="row" gap="0.5rem" justifyContent="center" marginBottom="0rem">
                          <Label sx={{ margin: "0rem" }} htmlFor="end_date">
                            Jusqu'à présent
                          </Label>
                          <Checkbox
                            onChange={(e) => {
                              setChecked(e.target.checked);
                              if (e.target.checked === true) setFieldValue("end_date", initialValuesFormation.end_date);
                              else setFieldValue("end_date", initialValuesFormation.end_date);
                            }}
                            checked={checked}
                            disableRipple
                            sx={{ padding: "0rem", marginBottom: "0.3rem" }}
                          />
                        </Box>
                      </Box>
                      <Field setFieldValue={setFieldValue} min={values.start_date} max={new Date()} disabled={checked} color={calendarColor} name="end_date" type="input" id="end_date" as={MyDP} autoComplete="off" />
                      <ErrorMessage component={ErrorText} name="end_date" />
                    </Box>
                  </Box>

                  <Box display="flex" flexDirection="row" justifyContent="center" gap="1.5rem" sx={{ mt: "1rem" }}>
                    <IconButton sx={{ padding: "0.5rem", bgcolor: `lightgreen`, "&:hover": { bgcolor: `lightgreen` } }} type="submit">
                      <DoneRoundedIcon sx={{ color: `${colors.main}` }} fontSize="large" />
                    </IconButton>

                    <IconButton sx={{ padding: "0.5rem", bgcolor: `lightgreen`, "&:hover": { bgcolor: `lightgreen` } }} onClick={() => setIsAddingFormation(false)}>
                      <ClearRoundedIcon sx={{ color: `${colors.main}` }} fontSize="large" />
                    </IconButton>
                  </Box>
                  {/* <Box width="6rem">
                    <pre>{JSON.stringify(values, null, 2)}</pre>
                    <pre>{JSON.stringify(checked, null, 2)}</pre>
                  </Box> */}
                </Form>
              )}
            </Formik>
          </Box>
        ) : (
          ""
        )}
      </Box>
    </Box>
  );
}

export default CvFormation;
